import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader, UncontrolledTooltip } from 'reactstrap'
import { getAllReferences, referenceDownload } from 'store/actions';
import CreateRefereceForm from './CreateRefereceForm';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TableContainer from 'components/Common/TableContainer';
import moment from 'moment'
import Spinners from 'components/Common/Spinner';
import { Link } from 'react-router-dom';

const References = () => {

  const dispatch = useDispatch();

  const { loading, error, responseMsg, isSubmitted, referenceList } = useSelector(state => state.ReferenceReducer)

  const [refModal, setRefModal] = useState({
    isShow: false,
    isEdit: false,
    isViewOnly: false,
    data: {}
  })



  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: (row, i) => i + 1,
        filterable: true,
        Cell: ({ row }) => {
          return <>{row.index + 1}</>;
        },
      },
      {
        Header: "Full Name",
        accessor: 'full_name',
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original.full_name}
            </>
          );
        },
      },
      {
        Header: "Phone No",
        accessor: "phone_no",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original.phone_no}
            </>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.email : ""}
            </>
          );
        },
      },
      {
        Header: "Address",
        accessor: "address",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.address : ""}
            </>
          );
        },
      },
      {
        Header: "Reference Code",
        accessor: "reference_code",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? cellProps.row.original.reference_code : ""}
            </>
          );
        },
      },
      {
        Header: "Created AT",
        accessor: "createdAt",
        filterable: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original ? moment(cellProps.row.original.createdAt).format("DD/MM/YYYY") : ""}
            </>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        filterable: true,
        Cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">

              <li>
                <Button
                  className="btn btn-sm btn-soft-info"
                  id={`files-${cellProps.row.original.id}`}
                  onClick={() => setRefModal({
                    isShow: true,
                    isEdit: false,
                    data: cellProps.row.original,
                    isViewOnly: true
                  })}
                >
                  <i className="mdi mdi-eye-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`reference-${cellProps.row.original.id}`}
                  >
                    View
                  </UncontrolledTooltip>
                </Button>
              </li>

              <li>
                <Button
                  className="btn btn-sm btn-soft-info"
                  id={`files-${cellProps.row.original.id}`}
                  onClick={() => setRefModal({
                    isShow: true,
                    isEdit: true,
                    data: cellProps.row.original,
                    isViewOnly: false
                  })}
                >
                  <i className="mdi mdi-pencil-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`reference-${cellProps.row.original.id}`}
                  >
                    Edit
                  </UncontrolledTooltip>
                </Button>
              </li>

              <li>
                <Link
                  className="btn btn-sm btn-soft-info"
                  to={`/reference-files/${cellProps.row.original.id}`}
                  state={{ isEdit: true }}
                  id={`reference-${cellProps.row.original.id}`}
                // onClick={() => {
                //   const Customer = cellProps.row.original
                //   handleCustomerClick(Customer)
                // }}
                >
                  <i className="mdi mdi-file-multiple" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`reference-${cellProps.row.original.id}`}
                  >
                    Files
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const handleCloseRefModal = () => {
    setRefModal({
      isShow: false,
      isEdit: false,
      data: {},
      isViewOnly: false
    })
  }

  useEffect(() => {
    if (isSubmitted) {
      handleCloseRefModal();
      dispatch(getAllReferences());
    }
  }, [isSubmitted])

  useEffect(() => {
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    if (responseMsg) {
      toast.success(responseMsg)
    }
  }, [responseMsg])


  useEffect(() => {
    dispatch(getAllReferences());
  }, [])
  return (
    <div className='page-content'>
      <div className='d-flex justify-content-between align-items-center'
        style={{ marginBottom: "20px" }}
      >
        
        <h2>References</h2>
        <div>
          <Button
            color='success'
            className='me-2'
            onClick={() => dispatch(referenceDownload())}
          >
            Download Reference
          </Button>

          <Button
            color='primary'
            onClick={() => setRefModal({
              ...refModal,
              isShow: true,
              isEdit: false,
              isViewOnly: false
            })}
          >
            New Reference
          </Button>
        </div>
      </div>


      <div>
        {/* Tables DIv */}
        <TableContainer
          columns={columns}
          Loading={loading}
          data={referenceList}
          isGlobalFilter={true}
          isAddOptions={false}
          // handleJobClicks={handleJobClicks}
          isJobListGlobalFilter={false}
          isPagination={true}
          iscustomPageSizeOptions={false}
          isShowingPageLength={true}
          customPageSize={20}
          tableClass="table-bordered align-middle nowrap mt-2"
          paginationDiv="col-sm-12 col-md-7"
          pagination="pagination justify-content-end pagination-rounded"
        />


        {
          loading ? <Spinners /> : ""
        }
      </div>

      <div>
        {/* Create/Edit Ref Modal */}

        <Modal isOpen={refModal.isShow} toggle={handleCloseRefModal}>
          <ModalHeader tag={"h4"} toggle={handleCloseRefModal}>
            Create New Reference
          </ModalHeader>

          <ModalBody>
            <CreateRefereceForm
              isEdit={refModal.isEdit}
              isShow={refModal.isShow}
              refData={refModal.data}
              isViewOnly={refModal.isViewOnly}
            />
          </ModalBody>
        </Modal>
      </div>
    </div>
  )
}

export default References